<template>
  <el-dialog
    width="500px"
    title="地图选点"
    :visible.sync="isDialog"
    append-to-body
  >
    <iframe
      width="100%"
      height="100%"
      style="border: none; width: 100%; height: 400px"
      allow="geolocation"
      :src="map_src"
    ></iframe>
  </el-dialog>
</template>

<script>
import { findByDictCode } from '@/api/system/common'

export default {
  data () {
    return {
      map_src:
        'https://mapapi.qq.com/web/mapComponents/locationPicker/v/index.html?search=1&type=1&key=3CDBZ-UR6CZ-TOLXF-7PF77-NRFNK-TCBXZ&referer=location',
      map_data: {
        address: '',
        lng: '',
        lat: '',
        name: ''
      },
      isDialog: false // 控制模态框
    }
  },
  created () {
    this.initMapSrc()
    this.getInfo()
  },
  methods: {
    // 初始化地图地址
    initMapSrc () {
      findByDictCode({ dictCode: 'sys_map_config' })
        .then((res) => {
          if (res && res.length > 0) {
            // 优先使用字典值作为URL
            this.map_src = res[0].code || res[0].label
          }
        })
        .catch((e) => {
          console.error('获取地图配置失败，使用默认地址', e)
        })
    },
    // 选择
    getInfo () {
      const that = this
      window.addEventListener(
        'message',
        function (event) {
          var loc = event.data
          if (loc && loc.module === 'locationPicker') {
            that.map_data.address = loc.poiaddress
            that.map_data.name = loc.poiname
            that.map_data.lat = loc.latlng.lat
            that.map_data.lng = loc.latlng.lng
            that.$emit('chooseOrgAddr', that.map_data)
          }
        },
        false
      )
    },
    // 父组件调用方法,打开模态框
    openDialog () {
      this.isDialog = true
    },
    // 关闭模态框
    closeDialog () {
      this.isDialog = false
    }
  }
}
</script>
